export enum PROGRAM_CARD_TYPE_ENUM {
	PREVENTIVE_EXAMINATION = 'preventive-examination',
	ANNUAL_PROGRAM = 'annual-program',
	MEDANTE_CREDIT = 'credit-program'
}
